import {SET_PAGES} from './pageActionTypes';

export function setPages(pages) {
    return {
        type: SET_PAGES,
        payload: pages,
    };
}
